module.exports = __webpack_public_path__ + "img/img-zhilian-s8-tuya.ee85ff07.jpg";